// extracted by mini-css-extract-plugin
export default {"linksWrapper":"styles_linksWrapper__duxn7","linkItem":"styles_linkItem__oCF21","avatar":"styles_avatar__b+vgr"};